module.exports = __webpack_public_path__ + "media/responsive/about-us-mobile-0143ce43.jpg";